import React, { useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { getLocale, getMessages } from './i18n';
import useAPI from './api';
import App from './App';

const LocalizedApp = function LocalizedApp() {
  const API = useAPI();
  const [translations, setTranslations] = useState(null);

  useEffect(() => {
    API.getTranslations(
      (res) => {
        setTranslations(
          Object.fromEntries(
            Object.entries(res).map(([key, value]) => [
              key.toUpperCase(),
              value,
            ])
          )
        );
      },
      () => {
        setTranslations({});
      }
    );
  }, []);

  const messages = useMemo(() => getMessages(translations), [translations]);

  const handleIntlError = (err) => {
    //remove missing translation errors
    if (err.code === 'MISSING_TRANSLATION') {
      return;
    }

    console.error(err);
  };

  // Route and section names exist only in the database catalogue: rendering before it answers
  // shows their keys. A failed call resolves to {} and the app renders on the bundled catalogue.
  if (!translations) return null;

  return (
    <IntlProvider
      locale={getLocale()}
      messages={messages}
      onError={handleIntlError}
    >
      <App />
    </IntlProvider>
  );
};

export default LocalizedApp;
